import { SidebarToggleIcon } from "../icons/SidebarToggleIcon"
import style from "./ElevationReferencesToggle.module.scss"

const { toggleButton, toggleButtonText, belowOneBar, belowTwoBars } = style

type Props = {
	onOpen: () => void
	/**
	 * How many full-width bars are currently stacked across the top of the document area — the
	 * jumping-nav bar and, below it, the connect-objects picker. The toggle drops below them so it
	 * stays reachable instead of hiding underneath.
	 */
	topBarCount?: 0 | 1 | 2
}

export const ElevationReferencesToggle = ({ onOpen, topBarCount = 0 }: Props) => {
	const clearance = topBarCount >= 2 ? belowTwoBars : topBarCount === 1 ? belowOneBar : ""
	return (
		<button className={`${toggleButton} ${clearance}`} onClick={onOpen}>
			<span className={toggleButtonText}>Elevation references</span>
			<SidebarToggleIcon />
		</button>
	)
}
